import {
  RawPageData,
  SFFProblemType
} from '../common/page-data';
import { PageData, VestigialData } from './page-data';
import { InputData } from './input-data';
import { ConstructData } from './construct-data';
import { IntroData } from './intro-data';
import { SkillCompletionData } from './skill-completion-data';
import { ModuleCompletionData } from './module-completion-data';
import { EvalData } from './eval-data';
import { DiscourseData } from './discourse-data';
import { FixedOptionData } from './fixed-option-data';
import { DiscourseFixedData } from './discourse-fixed-data';


type PageDataMap = {
  [type in SFFProblemType]: 
    typeof InputData | 
    typeof ConstructData |
    typeof DiscourseData |
    typeof EvalData |
    typeof IntroData |
    typeof ModuleCompletionData |
    typeof FixedOptionData |
    typeof SkillCompletionData |
    typeof VestigialData;
};

const pageDataMap: PageDataMap = {
  [SFFProblemType.ModuleIntro]: IntroData,
  [SFFProblemType.Type1]: InputData,
  [SFFProblemType.Type2]: InputData,
  [SFFProblemType.Type3]: InputData,
  [SFFProblemType.Type4]: InputData,
  [SFFProblemType.Type6]: ConstructData,
  [SFFProblemType.Type7]: InputData,
  [SFFProblemType.Discourse]: DiscourseData,
  [SFFProblemType.DiscourseFixed]: DiscourseFixedData,
  [SFFProblemType.SelfEval]: EvalData,
  [SFFProblemType.PeerEval]: EvalData,
  [SFFProblemType.ModuleCompletion]: ModuleCompletionData,
  [SFFProblemType.FixedOption]: FixedOptionData,
  [SFFProblemType.SkillCompletion]: SkillCompletionData,
  [SFFProblemType.TagAnnotation]: VestigialData,
  [SFFProblemType.AnnotateSingle]: VestigialData,
  [SFFProblemType.AnnotateMulti]: VestigialData,
  [SFFProblemType.Type5]: VestigialData,
}

/**
 * This will generate question/problem parameters object from raw serialized input data.
 * Mostly used to help display example or user data
 * 
 * @param rawPageData
 *    raw data that can come from loki logs or firebase event logs
 * @returns 
 */
export function pageDataFactory(rawPageData: RawPageData): PageData {
  const { type } = rawPageData;

  const DataType = pageDataMap[type];

  return new DataType({rawPageData});
}
